export const companies = {
  title: '公司',
  resourceName: '公司',
  titles: {
    list: '公司管理',
    create: '新增公司',
    edit: '编辑公司',
    detail: '公司详情',
    view: '公司详情',
    addQuick: '快速新增',
  },
  sections: {
    basic: '基本信息',
    note: '备注',
    audit: '系统',
  },
  fields: {
    code: '公司编码',
    name: '公司名称',
    country: '国家',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    isActive: '运营状态',
    onOffAction: '开 / 关',
    note: '备注',
    actions: '操作',
  },
  countries: {
    VietNam: '越南',
    TrungQuoc: '中国',
    HanQuoc: '韩国',
    NhatBan: '日本',
    Singapore: '新加坡',
    ThaiLan: '泰国',
    DaiLoan: '台湾',
    HongKong: '香港',
    My: '美国',
    Duc: '德国',
    Anh: '英国',
  },
  status: {
    active: '启用',
    inactive: '停用',
  },
  sortFields: {
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    tenCongTy: '公司名称',
    maCongTy: '公司编码',
    quocGia: '国家',
  },
  filter: {
    search: '搜索',
    searchPlaceholder: '编码或公司名称',
    status: '状态',
    statusAll: '全部',
    statusActive: '启用',
    statusInactive: '停用',
    sortField: '排序字段',
    sortDirection: '顺序',
    sortAsc: '升序',
    sortDesc: '降序',
  },
  validation: {
    codeNameRequired: '请输入公司编码和公司名称',
    codeDuplicated: '公司编码已存在',
    codeFormat: '公司编码仅可包含字母、数字、连字符与下划线',
  },
  messages: {
    noData: '暂无公司数据',
    totalCompanies: '总计: {total} 个公司',
    saving: '保存中...',
    savedSuccess: '保存成功',
    createSuccess: '创建公司成功',
    updateSuccess: '更新公司成功',
    deleteSuccess: '删除公司成功',
    statusToggleSuccess: '已更新公司状态',
    confirmDelete: '确认删除该公司吗？',
    notFound: '未找到公司',
    loadDetailError: '无法加载公司详情',
  },
}
